import React, { FC, ReactElement } from 'react';
import { Button as MuiButton, ButtonProps as MuiButtonProps } from '@material-ui/core';
import { Tooltip } from '../Tooltip';
import { SpriteIcon } from 'src/config/api/models/FontAwesome';
import { FontAwesomeSpriteIcon } from '../FontAwesomeLocal';
import theme from 'src/config/theme';

export type EditViewModeButtonProps = MuiButtonProps & {
  icon: SpriteIcon;
  tooltip?: string | ReactElement[];
};

const EditViewModeButton: FC<EditViewModeButtonProps> = ({
  children,
  disabled,
  icon,
  tooltip,
  ...restProps
}) => {
  const btn = (
    <MuiButton
      color="primary"
      variant="contained"
      disableRipple
      disabled={disabled}
      disableElevation={true}
      startIcon={<FontAwesomeSpriteIcon color={theme.palette.common.white} icon={icon} />}
      {...restProps}
    >
      {children}
    </MuiButton>
  );

  return tooltip && disabled ? (
    <Tooltip title={tooltip}>
      <span>{btn}</span>
    </Tooltip>
  ) : (
    btn
  );
};

export default EditViewModeButton;
